import { render } from "./KarussellRestaurant2.vue?vue&type=template&id=368d573d"
import script from "./KarussellRestaurant2.vue?vue&type=script&lang=js"
export * from "./KarussellRestaurant2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__